import React, { useState, useEffect } from 'react';
import { List, ListItemButton, ListItemText } from '@mui/material';
import ListSubheader from '@mui/material/ListSubheader';
import { useTranslation } from "react-i18next";
import secureLocalStorage from 'react-secure-storage';
import { agmsClientRequestGet } from '../../../apis/request';
import Button from '@mui/material/Button';
import moment from 'moment';

export default function ClickableList({userDeviceList, setUserDeviceDate}) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [myList, setMyList] = useState([]); 

  const handleListItemClick = (index, item) => {
    setUserDeviceDate(item.started_dt);
    setSelectedIndex(index);
  };

  // 측정 기간 = 브라우저 로컬(뷰어 TZ) 달력 날짜 기준. 시작~끝이 며칠에 걸쳤나(+1). last 없으면 진행 중(현재까지)
  const calcPeriodDay = (started, last) => {
    if (!started) return '';
    const end = (last === null || last === '') ? moment() : moment(last);
    return end.startOf('day').diff(moment(started).startOf('day'), 'days') + 1;
  };

  useEffect(async () => {
    if(secureLocalStorage.getItem('role') === '1001'){
        let response = await agmsClientRequestGet(`/api/user/all`);
        //console.log(response);
        setMyList(response);
    }
   


  },[]);
  const { t:translate, i18n } = useTranslation(); 
  return (
    <>
        <div style={{
            fontSize:'18px',
        }}>
            {
                secureLocalStorage.getItem('role') === '1001' ? 
                "사용자 목록"
                :
                translate("measurement_list")
            }
        </div>
    
        <div style={{
            height: secureLocalStorage.getItem('role') === '1001' ? '650px' : '400px',
            overflow:'auto',
        }}>
            <List style={{
            }}>

                {
                    secureLocalStorage.getItem('role') === '1001' ? 
                    <ListSubheader style={{
                        display:'flex',
                        flexDirection:'row',
                        borderTop:'2px solid #8A8A8A',
                        borderBottom:'1px solid #ccc'
                    }}>
                        <div style={{flex:1}}>
                            이름
                        </div>
                        <div style={{flex:1}}>
                            이메일
                        </div>
                    </ListSubheader>
                    :
                    <ListSubheader style={{
                        display:'flex',
                        flexDirection:'row',
                        borderTop:'2px solid #8A8A8A',
                        borderBottom:'1px solid #ccc' 
                    }}>
                        <div style={{flex:1}}>
                            {translate("serial_number")}
                        </div>
                        <div style={{flex:1}}>
                            {translate("measurement_period")}
                        </div>
                        <div style={{flex:1}}>
                            {translate("start_date")}
                        </div>
                        <div style={{flex:1}}>
                            {translate("end_date")}
                        </div>
                    </ListSubheader>

                }
                
                {
                    secureLocalStorage.getItem('role') === '1001' ? 
                    <>
                        {
                            myList.map((item, index) => (
                                <ListItemButton
                                    key={index}
                                    selected={selectedIndex === index}
                                    onClick={() => handleListItemClick(index, item)}
                                    style={{
                                        display:'flex',
                                        flexDirection:'row',
                                        borderBottom:'1px solid #ccc' 
                                    }}
                                >
                                    <ListItemText primary={item.name} style={{ flex:1, textAlign:'center'}}/>
                                    <ListItemText primary={item.email} style={{flex:1, textAlign:'center'}}/>
                                   
                                </ListItemButton>
                            ))
                        }
                    </>
                    :
                    <>
                        {
                            userDeviceList.map((item, index) => (
                                <ListItemButton
                                    key={index}
                                    selected={selectedIndex === index}
                                    onClick={() => handleListItemClick(index, item)}
                                    style={{
                                        display:'flex',
                                        flexDirection:'row',
                                        borderBottom:'1px solid #ccc' 
                                    }}
                                >
                                    <ListItemText primary={item.serial_number} style={{ flex:1, textAlign:'center'}}/>
                                    <ListItemText primary={calcPeriodDay(item.started_dt, item.last_dt) + ' ' +translate('day')} style={{flex:1, textAlign:'center'}}/>
                                    <ListItemText primary={moment(item.started_dt).format('YYYY-MM-DD HH:mm')} style={{flex:1, textAlign:'center'}}/>
                                    <ListItemText primary={item.last_dt === null || item.last_dt === '' ? '---': moment(item.last_dt).format('YYYY-MM-DD HH:mm')} style={{flex:1,textAlign:'center'}}/>
                                    {/* <ListItemText primary={'기기 시리얼 넘버 : ' + item.serial_number + ",    측정 기간 : " + item.started_dt + " ~ " + item.last_dt} /> */}
                                </ListItemButton>
                            ))
                        }
                    </>
                }
              
                
            </List>
        
        </div>
        {/* <hr style={{
            height:'3px',
            backgroundColor:'black'
        }}/> */}
    </>
    
    
  );
}